import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import { formatDZ } from '../../../utils/currency';

const WishlistSection = ({ wishlistItems, onMoveToCart, onRemoveFromWishlist }) => {
  if (wishlistItems?.length === 0) {
    return null;
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold command-text">Saved for Later</h2>
        <span className="text-sm text-muted-foreground">
          {wishlistItems?.length} item{wishlistItems?.length !== 1 ? 's' : ''}
        </span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {wishlistItems?.map((item) => (
          <div key={item?.id} className="holographic-card p-4 rounded-lg">
            <div className="space-y-4">
              {/* Product Image */}
              <div className="aspect-square rounded-lg overflow-hidden bg-muted/20">
                <Image
                  src={item?.image}
                  alt={item?.name}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Product Info */}
              <div className="space-y-2">
                <Link 
                  to={`/product/${item?.id}`}
                  className="font-semibold text-foreground hover:text-primary transition-colors line-clamp-2"
                >
                  {item?.name}
                </Link>
                <p className="text-sm text-muted-foreground">{item?.category}</p>
                
                {/* Price */}
                <div className="flex items-center space-x-2">
                  <span className="text-lg font-bold text-primary">
                    {formatDZ(item?.price)}
                  </span>
                  {item?.originalPrice && item?.originalPrice > item?.price && (
                    <span className="text-sm text-muted-foreground line-through">
                      {formatDZ(item?.originalPrice)}
                    </span>
                  )}
                </div>

                {/* Stock Status */}
                <div className="flex items-center space-x-2">
                  <div className={`inventory-pulse ${item?.stock > 10 ? 'high' : item?.stock > 5 ? 'medium' : 'low'}`}></div>
                  <span className="text-sm text-muted-foreground">
                    {item?.stock > 10 ? 'In Stock' : item?.stock > 0 ? `Only ${item?.stock} left` : 'Out of Stock'}
                  </span>
                </div>
              </div>

              {/* Actions */}
              <div className="flex space-x-2">
                <Button
                  variant="default"
                  size="sm"
                  onClick={() => onMoveToCart(item?.id)}
                  disabled={item?.stock === 0}
                  className="flex-1"
                >
                  <Icon name="ShoppingCart" size={16} className="mr-2" />
                  Add to Cart
                </Button>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => onRemoveFromWishlist(item?.id)}
                  className="text-muted-foreground hover:text-error"
                >
                  <Icon name="X" size={16} />
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WishlistSection;